export const hasSomeParentTheClass: any = function(element: HTMLElement, classname: string) {
	if (element.className && element.className.split(' ').indexOf(classname) >= 0)
		return true;

	return !!element.parentNode && hasSomeParentTheClass(element.parentNode as any, classname);
};

export const drupalSettingsData = function() {
	//@ts-ignore
	let settings: any = window['drupalSettings'] as any;
	return settings.bip_garage as Record<string, any> ;
};


// export const mergeIntoObject: any = function(target: object, source: object) {
// 	// @ts-ignore
// 	var obj3 = {};
// 	for (var attrname in target) { obj3[attrname] = target[attrname]; }
// 	for (var attrname in source) { obj3[attrname] = source[attrname]; }
// 	return obj3;
// };